/* CF: menu pictures (Trello: Menu Improvement - Imagery).
   Pictures in .cf-mm menus keep their real address in data-cf-mm-src and only load when that menu is opened:
   first the small pictures in the left list and the first sub-category's cards, then each sub-category's cards on hover.
   The page itself loads no extra images. */
(function () {
  if (window.cfMmReady) return;
  window.cfMmReady = true;

  function cfMmLoadIn(cfMmScope, cfMmSelector) {
    if (!cfMmScope) return;
    cfMmScope.querySelectorAll(cfMmSelector).forEach(function (cfMmImg) {
      var cfMmSrc = cfMmImg.getAttribute('data-cf-mm-src');
      if (!cfMmSrc) return;
      cfMmImg.src = cfMmSrc;
      cfMmImg.removeAttribute('data-cf-mm-src');
    });
  }

  function cfMmOnOver(cfMmEvent) {
    var cfMmTarget = cfMmEvent.target;
    if (!cfMmTarget.closest) return;

    var cfMmTop = cfMmTarget.closest('.nav-bar__item');
    if (!cfMmTop) return;
    var cfMmMenu = cfMmTop.querySelector(':scope > .cf-mm, :scope > .cf-mm-flat');
    if (!cfMmMenu) return;

    if (cfMmMenu.dataset.cfMmOpened !== '1') {
      cfMmMenu.dataset.cfMmOpened = '1';
      cfMmLoadIn(cfMmMenu, ':scope > li > a img[data-cf-mm-src]');
      cfMmLoadIn(cfMmMenu.querySelector(':scope > li'), 'img[data-cf-mm-src]');
    }

    var cfMmSub = cfMmTarget.closest('.cf-mm > li');
    if (cfMmSub) cfMmLoadIn(cfMmSub, 'img[data-cf-mm-src]');
  }

  document.addEventListener('mouseover', cfMmOnOver, { passive: true });
  document.addEventListener('focusin', cfMmOnOver);
})();


/* CF: hover intent for the full-width menus (Trello: Menu Improvement - Imagery).
   While a full-width menu is open and the mouse is moving down toward it, the other top-menu items the mouse
   passes over are ignored for a short moment, so the open menu does not switch or close on the way down. */
(function () {
  if (window.cfMmIntentReady) return;
  window.cfMmIntentReady = true;

  var cfMmIntentDelay = 350;
  var cfMmPointer = { x: 0, y: 0 };
  var cfMmPointerBefore = { x: 0, y: 0 };
  var cfMmIntentTimer = null;
  var cfMmReplaying = false;

  document.addEventListener('mousemove', function (cfMmEvent) {
    cfMmPointerBefore = cfMmPointer;
    cfMmPointer = { x: cfMmEvent.clientX, y: cfMmEvent.clientY };
  }, { passive: true });

  function cfMmOpenWideItem() {
    var cfMmItem = document.querySelector('.nav-bar__item.is-dropdown-open');
    if (!cfMmItem) return null;
    return cfMmItem.querySelector(':scope > .cf-mm, :scope > .cf-mm-flat, :scope > .mega-menu') ? cfMmItem : null;
  }

  function cfMmMovingDown() {
    return cfMmPointer.y - cfMmPointerBefore.y > 0;
  }

  function cfMmSettle(cfMmOpenItem, cfMmOtherLink) {
    var cfMmUnder = document.elementFromPoint(cfMmPointer.x, cfMmPointer.y);
    if (cfMmUnder && cfMmOpenItem.contains(cfMmUnder)) return; /* reached the open menu: keep it */
    cfMmReplaying = true;
    cfMmOpenItem.dispatchEvent(new MouseEvent('mouseout', { bubbles: true, relatedTarget: cfMmUnder || document.body }));
    if (cfMmUnder && cfMmOtherLink.contains(cfMmUnder)) {
      cfMmOtherLink.dispatchEvent(new MouseEvent('mouseover', { bubbles: true, relatedTarget: cfMmOpenItem }));
    }
    cfMmReplaying = false;
  }

  /* Hold back the other top item from opening while heading down into the open menu */
  document.addEventListener('mouseover', function (cfMmEvent) {
    if (cfMmReplaying || !cfMmEvent.target.closest) return;
    var cfMmLink = cfMmEvent.target.closest('.nav-bar__item > [data-type="menuitem"][aria-haspopup]');
    if (!cfMmLink) return;
    var cfMmOpenItem = cfMmOpenWideItem();
    if (!cfMmOpenItem || cfMmOpenItem.contains(cfMmLink) || !cfMmMovingDown()) return;
    cfMmEvent.stopImmediatePropagation();
    clearTimeout(cfMmIntentTimer);
    cfMmIntentTimer = setTimeout(function () { cfMmSettle(cfMmOpenItem, cfMmLink); }, cfMmIntentDelay);
  }, true);

  /* Hold back the open menu from closing while passing over the other top items */
  document.addEventListener('mouseout', function (cfMmEvent) {
    if (cfMmReplaying) return;
    var cfMmOpenItem = cfMmOpenWideItem();
    if (!cfMmOpenItem || !cfMmOpenItem.contains(cfMmEvent.target)) return;
    var cfMmGoingTo = cfMmEvent.relatedTarget;
    var cfMmGoingItem = cfMmGoingTo && cfMmGoingTo.closest && cfMmGoingTo.closest('.nav-bar__item');
    if (!cfMmGoingItem || cfMmGoingItem === cfMmOpenItem || !cfMmMovingDown()) return;
    cfMmEvent.stopImmediatePropagation();
  }, true);
})();


/* CF: warm-up. As soon as the mouse touches the menu bar, start loading the small pictures of every menu's
   left list, so they are ready by the time a menu opens. Nothing loads with the page itself. */
(function () {
  if (window.cfMmWarmReady) return;
  window.cfMmWarmReady = true;
  var cfMmNavBar = document.querySelector('.nav-bar');
  if (!cfMmNavBar) return;
  function cfMmWarmUp() {
    cfMmNavBar.removeEventListener('mouseenter', cfMmWarmUp);
    cfMmNavBar.querySelectorAll('.cf-mm > li > a img[data-cf-mm-src]').forEach(function (cfMmImg) {
      cfMmImg.src = cfMmImg.getAttribute('data-cf-mm-src');
      cfMmImg.removeAttribute('data-cf-mm-src');
    });
  }
  cfMmNavBar.addEventListener('mouseenter', cfMmWarmUp);
})();

/* CF: always show 2 full rows of picture cards without scrolling (Steve, Oct 19).
   The cards keep their normal width and layout. Only when the screen is too short for two rows,
   the picture area of the cards gets a little lower (down to 80px) until the 2nd row fits completely.
   Measured each time a menu opens on a new screen size, for each sub-category on its own. */
(function () {
  if (window.cfMmTwoRowsReady) return;
  window.cfMmTwoRowsReady = true;

  var cfMmImgMin = 80;
  var cfMmImgStep = 5;
  var cfMmBottomGap = 12;

  function cfMmTwoRowsBottom(cfMmCards) {
    var cfMmRowTops = [];
    var cfMmLowest = 0;
    for (var i = 0; i < cfMmCards.length; i++) {
      var cfMmRect = cfMmCards[i].getBoundingClientRect();
      var cfMmTop = Math.round(cfMmRect.top);
      if (cfMmRowTops.indexOf(cfMmTop) === -1) cfMmRowTops.push(cfMmTop);
      if (cfMmRowTops.length > 2) break;
      cfMmLowest = Math.max(cfMmLowest, cfMmRect.bottom);
    }
    return cfMmLowest;
  }

  function cfMmFitSub(cfMmMenu, cfMmSub) {
    var cfMmList = cfMmSub.querySelector('.cf-mm-cards ul');
    if (!cfMmList || cfMmList.children.length === 0) return;
    cfMmList.style.removeProperty('--cf-mm-img-h');
    cfMmList.style.removeProperty('grid-template-columns');
    var cfMmCards = cfMmList.children;
    var cfMmFullHeight = Math.round(cfMmCards[0].getBoundingClientRect().width);
    var cfMmLimit = Math.min(cfMmMenu.getBoundingClientRect().bottom, window.innerHeight - cfMmBottomGap);
    if (cfMmTwoRowsBottom(cfMmCards) <= cfMmLimit) return;

    for (var cfMmHeight = cfMmFullHeight - cfMmImgStep; cfMmHeight >= cfMmImgMin; cfMmHeight -= cfMmImgStep) {
      cfMmList.style.setProperty('--cf-mm-img-h', cfMmHeight + 'px');
      if (cfMmTwoRowsBottom(cfMmCards) <= cfMmLimit) return;
    }
  }

  function cfMmFitMenu(cfMmMenu) {
    var cfMmSpace = window.innerHeight - cfMmMenu.getBoundingClientRect().top - cfMmBottomGap;
    if (cfMmSpace > 0) cfMmMenu.style.setProperty('--cf-mm-space', cfMmSpace + 'px');
    cfMmMenu.querySelectorAll(':scope > li > .sub_collection').forEach(function (cfMmSub) {
      cfMmFitSub(cfMmMenu, cfMmSub);
    });
    cfMmMenu.dataset.cfMmFitted = String(window.innerWidth) + 'x' + String(window.innerHeight);
  }

  document.addEventListener('mouseover', function (cfMmEvent) {
    if (!cfMmEvent.target.closest || window.innerWidth < 1000) return;
    var cfMmItem = cfMmEvent.target.closest('.nav-bar__item');
    var cfMmMenu = cfMmItem && cfMmItem.querySelector(':scope > .cf-mm');
    if (!cfMmMenu) return;
    var cfMmScreen = String(window.innerWidth) + 'x' + String(window.innerHeight);
    if (cfMmMenu.dataset.cfMmFitted === cfMmScreen) return;
    requestAnimationFrame(function () { cfMmFitMenu(cfMmMenu); });
  }, { passive: true });
})();


/* CF D1 page weight + speed: the picture cards are not built into every page any more (the photo lookups made pages
   slow to build, and Google only reads the first 2 MB of a page). Each sub-category has plain text links in the page.
   The first time a sub-category is shown (the first one when its menu opens, the others on hover or keyboard focus),
   its cards load from <sub-category collection URL>?view=cf-mm-cards (templates/collection.cf-mm-cards.liquid) and
   replace the text links. If a request fails, the text links stay and work, and the next visit tries again. */
(function () {
  if (window.cfMmCardsReady) return;
  window.cfMmCardsReady = true;

  function cfMmCardsLoadSub(cfMmSub) {
    if (!cfMmSub) return;
    var cfMmTextList = cfMmSub.querySelector('.cf-mm-cards ul[data-cf-mm-text]');
    if (!cfMmTextList || cfMmTextList.dataset.cfMmLoading === '1') return;
    var cfMmHead = cfMmSub.querySelector('.head_menu a[href]');
    if (!cfMmHead) return;
    cfMmTextList.dataset.cfMmLoading = '1';
    var cfMmUrl = cfMmHead.getAttribute('href');
    cfMmUrl += (cfMmUrl.indexOf('?') === -1 ? '?' : '&') + 'view=cf-mm-cards';
    fetch(cfMmUrl, { credentials: 'same-origin' })
      .then(function (cfMmRes) {
        if (!cfMmRes.ok) throw new Error('cf-mm-cards ' + cfMmRes.status);
        return cfMmRes.text();
      })
      .then(function (cfMmHtml) {
        var cfMmDoc = new DOMParser().parseFromString(cfMmHtml, 'text/html');
        var cfMmKey = cfMmTextList.getAttribute('data-cf-mm-key');
        var cfMmSource = null;
        cfMmDoc.querySelectorAll('ul[data-cf-mm-key]').forEach(function (cfMmList) {
          if (cfMmList.getAttribute('data-cf-mm-key') === cfMmKey) cfMmSource = cfMmList;
        });
        if (!cfMmSource || !cfMmSource.children.length) throw new Error('cf-mm-cards empty');
        cfMmTextList.innerHTML = cfMmSource.innerHTML;
        cfMmTextList.removeAttribute('data-cf-mm-text');
        cfMmTextList.querySelectorAll('img[data-cf-mm-src]').forEach(function (cfMmImg) {
          cfMmImg.src = cfMmImg.getAttribute('data-cf-mm-src');
          cfMmImg.removeAttribute('data-cf-mm-src');
        });
        var cfMmMenu = cfMmSub.closest('.cf-mm');
        if (cfMmMenu) delete cfMmMenu.dataset.cfMmFitted;
      })
      .catch(function () { delete cfMmTextList.dataset.cfMmLoading; });
  }

  function cfMmCardsOnEnter(cfMmEvent) {
    if (!cfMmEvent.target.closest) return;
    var cfMmItem = cfMmEvent.target.closest('.nav-bar__item');
    var cfMmMenu = cfMmItem && cfMmItem.querySelector(':scope > .cf-mm');
    if (!cfMmMenu) return;
    cfMmCardsLoadSub(cfMmMenu.querySelector(':scope > li'));
    var cfMmHovered = cfMmEvent.target.closest('.cf-mm > li');
    if (cfMmHovered) cfMmCardsLoadSub(cfMmHovered);
  }

  document.addEventListener('mouseover', cfMmCardsOnEnter, { passive: true });
  document.addEventListener('focusin', cfMmCardsOnEnter);
  document.addEventListener('touchstart', cfMmCardsOnEnter, { passive: true });
})();
